import * as yup from 'yup'

export const schema = yup.object({
    dataInicio: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    dataFinal: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    registro: yup.string(),
    numeroContrato: yup.string(),
    chassi: yup.string().max(25, 'Chassi deve ter no máximo 25 caracteres'),
    tipoOperacao: yup.string(),
    placa: yup.string(),
    situacaoRegistro: yup.string(),
    nomeCredor: yup.string(),
    nomeDevedor: yup.string(),
    municipioDevedor: yup.string(),
    ufDevedor: yup.string(),
    marcaModelo: yup.string(),
    anoModelo: yup
        .string()
        .nullable()
        .notRequired()
        .matches(/^\d{4}$/, { message: 'Ano deve ter exatamente 4 dígitos', excludeEmptyString: true }),
    documentoDevedor: yup.string().max(14, 'N° Documento deve ter no máximo 14 digitos'),
    especie: yup
        .number()
        .transform((value, originalValue) => originalValue === '' ? 10 : value)
        .nullable()
        .notRequired(),
    renavam: yup.string()
})
